import { SequenceMenu } from '@sequencehq/core-components'
import { IntegrationServices } from '@sequencehq/api'
import { integrationName } from 'lib/integrations/integrationName'
import { getLogo } from 'lib/integrations/logos'

export const LinkCustomerMenuItem = (props: {
  customerId: string
  service: IntegrationServices
  onSelect: () => void
  onMenuClose?: () => void
}) => {
  return (
    <SequenceMenu.Item
      uuid={`link-${props.service}`}
      label={`Link to ${integrationName(props.service)}`}
      iconRight={getLogo(props.service, 18)}
      data-testid={`customers.${props.customerId}.menuItem.linkTo${props.service}`}
      onClick={() => {
        props.onSelect()
        props.onMenuClose?.()
      }}
    />
  )
}
